import DiscountIssueTable from './DiscountIssueTable'

export default DiscountIssueTable
